import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { MVP_CRITERIA, MVP_PATHS } from './salesData';
export function MethodSection() {
  return <section id="metodo" className="bg-charcoal py-14 text-white sm:py-20" data-id="element-133" data-mp="2v09bizldu92">
      <div className="mx-auto max-w-5xl px-5" data-id="element-134" data-mp="3uyjdptyqolu2">
        <div className="text-center" data-id="element-135" data-mp="3uzuctgh8p5eu">
          <h2 className="mx-auto max-w-[20ch] font-display text-[1.7rem] font-extrabold leading-[1.1] tracking-tight sm:max-w-[28ch] sm:text-[2.5rem]" data-id="element-136" data-mp="vimntmacyjap">
            Tu primera venta no empieza con 100 recetas.
            <span className="mt-1.5 block text-coral" data-id="element-137" data-mp="lsl2h29e3ezh">Empieza eligiendo 5.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-[44ch] font-sans text-[0.93rem] leading-relaxed text-white/75 sm:max-w-2xl sm:text-[1rem]" data-id="element-138" data-mp="hs14jwgzs7ca">
            Las 100 recetas son tu biblioteca de posibilidades. El{' '}
            <strong className="font-bold text-white" data-id="element-139" data-mp="19if9v4axwbcc">
              Método M.V.P.™ — Menú Vendible de Partida
            </strong>{' '}
            es el sistema para decidir por dónde empezar.
          </p>
        </div>

        <div className="mt-9 grid gap-7 lg:grid-cols-[minmax(0,0.8fr)_minmax(0,1.2fr)] lg:items-start lg:gap-12" data-id="element-140" data-mp="2000nb9x5amr3">
          <div data-id="element-141" data-mp="1lc5rhknuc29s">
            <h3 className="font-display text-[0.68rem] font-bold uppercase tracking-editorial text-coral" data-id="element-142" data-mp="1lact0sndsocv">
              Elegís según
            </h3>
            <ul className="mt-3.5 grid grid-cols-2 gap-2" data-id="element-143" data-mp="1capt6baavqlx">
              {MVP_CRITERIA.map(c => <li key={c} className="flex items-center gap-2 rounded-xl bg-white/[0.07] px-3 py-2 font-sans text-[0.79rem] font-medium text-white/90" data-id="element-144" data-mp="1hbvl46w4z9ue">
                  <CheckIcon className="h-3.5 w-3.5 shrink-0 text-coral" aria-hidden strokeWidth={3} data-id="element-145" data-mp="17dfue510u2lf" />
                  {c}
                </li>)}
            </ul>
          </div>

          <div data-id="element-146" data-mp="31pmiu5ixefvo">
            <h3 className="font-display text-[0.68rem] font-bold uppercase tracking-editorial text-coral" data-id="element-147" data-mp="31q5q8say9lvg">
              Tres caminos para arrancar
            </h3>
            <div className="mt-3.5 grid gap-2.5" data-id="element-148" data-mp="2va5uqi0pacvu">
              {MVP_PATHS.map((path, i) => <motion.div key={path.name} initial={{
              opacity: 0,
              y: 12
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              margin: '-60px'
            }} transition={{
              duration: 0.26,
              ease: [0.23, 1, 0.32, 1],
              delay: i * 0.05
            }} className="rounded-2xl bg-white/[0.07] p-4 ring-1 ring-white/10 sm:p-5" data-id="element-149" data-mp="2qaszp9zodzi6" data-mpi={i}>
                  <p className="font-display text-[1rem] font-bold tracking-tight text-white sm:text-[1.15rem]" data-id="element-150" data-mp="398vp3pw4xygi">
                    {path.name}
                  </p>
                  <p className="mt-1 font-sans text-[0.85rem] leading-relaxed text-white/70" data-id="element-151" data-mp="5ln4qj86nc65">
                    {path.desc}
                  </p>
                </motion.div>)}
            </div>
          </div>
        </div>

        <div className="mt-9 flex justify-center" data-id="element-152" data-mp="1jips2w02ho79">
          <CTAButton className="w-full max-w-[26rem] px-4" data-id="element-153" data-mp="1ofydd5gii8cq" />
        </div>
      </div>
    </section>;
}